export const emailPattern =
  "[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}";

export const emailRegex = new RegExp(emailPattern);

export const isValidEmail = (text: string): boolean => {
  return emailRegex.test(text);
};
